(function () {
  'use strict';

  /* @ngdoc object
   * @name crewViolations
   * @description
   *
   */
  angular
    .module('minRestBreachPriorToRktDeparture', [
      'ui.router'
    ]);
}());
